class Modal extends HTMLElement {
    constructor() {
        super();
        this.btnEventListeners();
    }

    btnEventListeners() {
        const { modalTriggers } = this.modalComponents();

        modalTriggers.forEach(modal => {
            modal.addEventListener('click', () => {
                this.toggleModal(modal.dataset.modal);
            })
        });
    }

    toggleModal(modalID) {
        if(document.getElementById(modalID) == null) {
            console.log(`Modal with ID ${modalID} does not exist!`);
            return;
        }
        this.toggleOverlay();
        const modal = document.getElementById(modalID);
        modal.classList.toggle('hidden');
    }

    toggleOverlay() {
        const { overlay } = this.modalComponents();
        overlay.classList.toggle('hidden');
    }

    modalComponents() {
        const overlay = document.getElementById('overlay-background');
        const modalTriggers = document.querySelectorAll('.modal-trigger');
        return { overlay, modalTriggers }
    }
}

customElements.define('modal-component', Modal);